<script>
  export default {
    props: {
      messages: Array,
    },
    render(h) {
      return h();
    },

    mounted() {
      _.each(this.messages, ({message, type: type = 'info'}) => {
        this.$message({message, type});
      });
    },
  }
</script>

